var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevTableBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 28.0002C12.1667 22.0294 12.1667 19.0432 14.0224 17.1892C15.8765 15.3335 18.8627 15.3335 24.8334 15.3335H31.1667C37.1375 15.3335 40.1237 15.3335 41.9777 17.1892C43.8334 19.0432 43.8334 22.0294 43.8334 28.0002C43.8334 33.9709 43.8334 36.9571 41.9777 38.8112C40.1237 40.6668 37.1375 40.6668 31.1667 40.6668H24.8334C18.8627 40.6668 15.8765 40.6668 14.0224 38.8112C12.1667 36.9571 12.1667 33.9709 12.1667 28.0002Z",
    stroke: "url(#paint0_linear_5083_10710)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8334 35.1252H18.5001M21.6667 30.3752H18.5001M12.1667 24.8335H43.8334",
    stroke: "url(#paint1_linear_5083_10710)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 32.7502C31.1667 31.2571 31.1667 30.5113 31.6307 30.0474C32.0946 29.5835 32.8403 29.5835 34.3334 29.5835C35.8265 29.5835 36.5722 29.5835 37.0362 30.0474C37.5001 30.5113 37.5001 31.2571 37.5001 32.7502C37.5001 34.2432 37.5001 34.989 37.0362 35.4529C36.5722 35.9168 35.8265 35.9168 34.3334 35.9168C32.8403 35.9168 32.0946 35.9168 31.6307 35.4529C31.1667 34.989 31.1667 34.2432 31.1667 32.7502Z",
    stroke: "url(#paint2_linear_5083_10710)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5083_10710",
    x1: 12.1667,
    y1: 15.3335,
    x2: 36.8822,
    y2: 46.2278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5083_10710",
    x1: 12.1667,
    y1: 24.8335,
    x2: 18.2172,
    y2: 43.4504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5083_10710",
    x1: 31.1667,
    y1: 29.5835,
    x2: 37.5001,
    y2: 35.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevTableBox);
export default __webpack_public_path__ + "static/media/revTableBox.93731b6bb827a325d88ccfc8a299e88e.svg";
export { ForwardRef as ReactComponent };